import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.172 2.012C6.922 1.364 7.939 1 9 1c1.06 0 2.078.364 2.828 1.012S13 3.538 13 4.455V7h-1.263V4.455c0-.627-.289-1.229-.802-1.672-.513-.443-1.21-.692-1.935-.692-.726 0-1.422.249-1.935.692-.514.443-.802 1.045-.802 1.672V7H5V4.455c0-.917.421-1.795 1.172-2.443Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3 5h12v6.6c0 1.037 0 1.814-.082 2.414-.083.6-.249 1.02-.576 1.34l-.001.002c-.33.322-.759.483-1.373.563C12.357 16 11.56 16 10.5 16h-3c-1.06 0-1.856 0-2.469-.08-.613-.081-1.042-.243-1.371-.564h-.001c-.33-.323-.494-.742-.577-1.342C3 13.414 3 12.636 3 11.6V5Zm1.125 1.1v5.5c0 1.068.003 1.758.072 2.267.066.477.171.626.257.71.087.085.24.188.727.252.52.068 1.227.071 2.319.071h3c1.092 0 1.8-.003 2.319-.07.487-.065.64-.168.726-.252.086-.085.192-.235.258-.71.07-.51.072-1.2.072-2.268V6.1h-9.75Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }